'use client'

import classNames from 'classnames'

import GlobalErrorPage from '@/components/global-error-page'
import { iconFont, primaryFont } from '@/styles/fonts'

import '@/styles/main.scss'

/**
 * Last-resort error boundary to replace generic next.js error
 */
export default function GlobalError(props: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <GlobalErrorPage
      {...props}
      bodyClassName={classNames(primaryFont.variable, iconFont.variable)}
    />
  )
}
